import { Box } from '@mui/material'
import TruncatedText from './TruncatedText'
import { memo, ReactElement, useCallback } from 'react'
import { useAppSelector } from '../../redux/hook'

export interface IURLTypeData {
    dataValue: string
}

const URLTypeData = ({ dataValue }: IURLTypeData): ReactElement => {
    const isGuestUser =
        useAppSelector((state) => state.searchParams.isGuestUser) === 'true'
    const onClickURL = useCallback(() => {
        if (isGuestUser) {
            return
        }
        const selectedCellURL = dataValue
        const encodedText = selectedCellURL.startsWith('http')
            ? selectedCellURL
            : `https://${selectedCellURL}`
        window.open(encodedText, '_blank', 'noopener,noreferrer')?.focus()
    }, [dataValue, isGuestUser])

    return (
        <Box
            id="url-type-link"
            onClick={onClickURL}
            sx={{
                color: !isGuestUser ? '#6d6dff' : '',
                cursor: !isGuestUser ? 'pointer' : '',
                width: '100%',
            }}
        >
            <TruncatedText
                sx={{ fontSize: '14px' }}
                text={dataValue ? 'Click here' : ''}
            />
        </Box>
    )
}

const MemoizedURLTypeData = memo(URLTypeData)
MemoizedURLTypeData.displayName = 'URLTypeData'
export default MemoizedURLTypeData
